var App = App || {};

App.ResourcesItems = (function ($) {
    'use strict';

    function Init(widget) {

        const carousel = widget.find(".splide");

        if (!carousel.length)
            return false;

        Carousel(carousel);
    }

    function Carousel(carousel) {
        var slideCount = carousel.find(".widget-resource-item").length;

        let splideInstance = null;
        const breakpoint = 992;

        function toggleSplide() {
            if (slideCount >= 2) {
                const isMobile = $(window).width() <= breakpoint;

                if (isMobile) {
                    if (!splideInstance) {
                        splideInstance = new Splide(carousel[0], {
                            type: "loop",
                            focus: "1",
                            pagination: false,
                            perPage: 2,
                            perMove:1,
                            drag: false,
                            pauseOnFocus:false,
                            fixedWidth: "70%",
                            arrows: true,
                        });
                        splideInstance.mount({});
                    }
                } else {
                    if (splideInstance) {
                        splideInstance.destroy();
                        splideInstance = null;
                    }
                }

                if (splideInstance) {
                    splideInstance.on('move', function (newIndex, prevIndex) {
                        const slideNew = $(splideInstance.Components.Slides.getAt(newIndex).slide);
                        const slideOld = $(splideInstance.Components.Slides.getAt(prevIndex).slide);

                        slideNew.addClass("is-active");
                        slideOld.removeClass("is-active");
                    });
                }
            }
        }

        $(window).on("enter-xxl enter-xl enter-lg enter-md enter-sm enter-xs", function () {
            var bp = ZagBreakpoints.GetBreakpoint();
            toggleSplide();
        });

        toggleSplide();

    }

    return {
        Init: Init
    };

})(jQuery);

